import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../layouts/se.layout.widget.abstract";
import { Layouts } from "../layouts/se.layouts";
import { SeOrgSecurityStore } from "../se.org.security.store";
import { ManageEventSurveyConfigComponent } from "../attendance/se.manage.event.survey.config.component";
import { SEEventDetailsStore } from "./se.event.details.store";

@Component({
    standalone: true,
    selector: "s25-ng-se-event-details-survey-config-widget",
    template: `
        @if (orgSecStore.canViewSurveyConfig()) {
            <s25-ng-manage-event-survey-config
                [eventId]="eventStore.eventId()"
                [readonly]="!orgSecStore.canManageSurveyConfig()"
            />
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ManageEventSurveyConfigComponent],
})
export class SeEventDetailsSurveyConfigWidgetComponent extends LayoutWidget<
    typeof SeEventDetailsSurveyConfigWidgetComponent
> {
    static readonly META = {
        name: "Survey Configuration",
        info: "Configure event surveys when your role can view survey configuration",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected eventStore = inject(SEEventDetailsStore);
    protected orgSecStore = inject(SeOrgSecurityStore);
}
